function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgError(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "scale(2)"
  }, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#f44336"
    },
    cx: 8,
    cy: 8,
    r: 7
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#ffffff"
    },
    width: 2,
    height: 10,
    x: -0.98,
    y: -16.29,
    transform: "rotate(135)"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#ffffff"
    },
    width: 2,
    height: 10,
    x: -12.29,
    y: -5.01,
    transform: "rotate(-135)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgError);
export default __webpack_public_path__ + "static/media/error.acf7301b3a948311e75a1f9b0ef80b3d.svg";
export { ForwardRef as ReactComponent };